import axios from "axios";
import { ethers } from "ethers";
import Web3 from "web3";
import environmentVariables from "../config/environmentVariables.js";
const gameDashboardUrl = environmentVariables.gameDashboardUrl||process.env.REACT_APP_GAME_DASHBOARD_URL||"https://gdbe.metaspacechain.com";
let rpcUrl = null;
let ethersProvider = null;
let web3Provider = null;

export const initRPC = async () => {
  try {
    if (rpcUrl) return rpcUrl;

  const response = await axios.get(
    `${gameDashboardUrl}/dashboard/api/v1/rpc/fetch/nftmarketplaceweb`
  );

  rpcUrl = response.data.url;

  ethersProvider = new ethers.JsonRpcProvider(rpcUrl);
  web3Provider = new Web3(rpcUrl);

  return rpcUrl;
  }catch (error) {
    console.error("Error fetching RPC URL:", error);
    return "https://polygon-mainnet.infura.io/v3/8cc9a225361c451e9594fd5409930f6f"; // Fallback RPC URL
  }
};

export const getRPCUrl = () => rpcUrl;

export const getEthersProvider = () => ethersProvider;

export const getWeb3Provider = () => web3Provider;